'use client';

import { c as _c } from "react/compiler-runtime";
import { GlobeButton } from '@/components/globe/globe-button';
import { ListingDiscoveryActions, type ListingDiscoveryControlsProps } from '@/components/shared/listing-discovery-actions';
import { StartDebateLink } from '@/components/shared/start-debate-link';
import { MarketsInfoAction } from './markets-info-action';
export function MarketsDiscoveryActions(props) {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <GlobeButton mode="market" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <StartDebateLink />;
    t2 = <MarketsInfoAction />;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== props) {
    t3 = <div className="flex shrink-0 items-center gap-0">{t0}<ListingDiscoveryActions {...props} creationAction={t1}>{t2}</ListingDiscoveryActions></div>;
    $[3] = props;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}